export default function authHeader() {

    let header = JSON.parse(localStorage.getItem('header'));

    if (header && header.accessToken) {
        return header
    }
}